// @ts-nocheck
import * as React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import styles from "./styles.css";

export default function HamburgerButton({ isNavOpen, onClick }) {
    return (
        <button className={styles.hamburgerButton} onClick={onClick}>
            <div
                className={cn(styles.hamburgerIcon, {
                    [styles["hamburgerIcon--open"]]: isNavOpen,
                })}
            >
                <span />
                <span />
                <span />
                <span />
            </div>
        </button>
    );
}

HamburgerButton.propTypes = {
    isNavOpen: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
